export const HIDE_MAIN_MENU_ON_SELECTION_KEY = 'hide-main-menu-on-selection';
